query emproContactsCount($input: EmproSelectedContactStatusesInput!) {
    emproContactsCount(input: $input) {
        countPerStatus
    }
}
